import { render, staticRenderFns } from "./CartTotals.vue?vue&type=template&id=1d704c2f&scoped=true&lang=pug&"
import script from "./CartTotals.vue?vue&type=script&lang=js&"
export * from "./CartTotals.vue?vue&type=script&lang=js&"
import style0 from "./CartTotals.vue?vue&type=style&index=0&id=1d704c2f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d704c2f",
  null
  
)

export default component.exports